// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9211b97a","453":"03387e17","667":"fb564484"}[chunkId] + ".chunk.js";
};